import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface NavigationMessage {
  type: "navigate";
  url: string;
}

function isNavigationMessage(value: unknown): value is NavigationMessage {
  return (
    typeof value === "object" &&
    value !== null &&
    (value as { type?: unknown }).type === "navigate" &&
    typeof (value as { url?: unknown }).url === "string"
  );
}

export function useServiceWorkerNavigation(): void {
  const navigate = useNavigate();
  useEffect(() => {
    if (typeof navigator === "undefined") return;
    if (!("serviceWorker" in navigator)) return;
    const handler = (event: MessageEvent) => {
      if (!isNavigationMessage(event.data)) return;
      try {
        const target = new URL(event.data.url, window.location.origin);
        navigate(`${target.pathname}${target.search}`);
      } catch {
        // ignore malformed URLs
      }
    };
    navigator.serviceWorker.addEventListener("message", handler);
    return () => {
      navigator.serviceWorker.removeEventListener("message", handler);
    };
  }, [navigate]);
}
